import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import Avatar from 'v2/Avatar/Avatar';
import { RootState } from 'v2/models';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './settingsDropdown.module.scss';
import classnames from 'classnames';
import { ReactComponent as GearIcon } from 'v2/icons/simple-gear.svg';
import { ReactComponent as HelpIcon } from 'v2/icons/help.svg';
import { ReactComponent as LogoutIcon } from 'v2/icons/logout.svg';
import { onLogout } from 'v2/utils/logout';

interface SettingsDropdownProps {
  show: boolean;
  showSettings: boolean;
  handleExpand: (expanded: boolean) => void;
}

export const SettingsDropdown = ({
  show,
  showSettings,
  handleExpand,
}: SettingsDropdownProps) => {
  const user = useSelector((state: RootState) => state.user.user);

  const getAvatar = () => (
    <Avatar
      url={user.avatar?.url}
      initials={`${user.first_name?.[0] ?? ''}${user.last_name?.[0] ?? ''}`}
    />
  );

  return show ? (
    <NavDropdown
      title={getAvatar()}
      id="nav-dropdown-settings"
      onSelect={() => handleExpand(false)}
      className={classnames(styles.settingsDropdown)}
      data-testid="settingsDropdown"
    >
      {showSettings && (
        <NavDropdown.Item as={Link} to="/settings/account">
          <GearIcon />
          Settings
        </NavDropdown.Item>
      )}

      <NavDropdown.Item href="https://help.nomad-data.com" target="_blank">
        <HelpIcon />
        Help
      </NavDropdown.Item>

      <NavDropdown.Item as={Link} to="/logout" onClick={onLogout}>
        <LogoutIcon />
        Logout
      </NavDropdown.Item>
    </NavDropdown>
  ) : null;
};
